<!--
================================================
Composant gérant le formulaire de choix du thème préféré
http://localhost:8080/fr/cronocloud-inc/user/settings
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div>

    <div class="formSection " id="formSectionTheme">

      <div class="spacer">

        <div class="contTitle has-text-left">
          <h3 class="">
            <font-awesome-icon class="icon" :icon="['fas', 'adjust']"/>
            {{ $t('Theme') }}
          </h3>
        </div>

        <form action="" v-on:keyup.enter="validateBeforeSubmit">

          <div class="field is-horizontal">

            <div class="control">
              <p class="help">{{ $t('choisissezVotreThemePrefere') }}</p>
              <br>

              <div class="select is-pulled-left">
                <select v-model="preferedTheme" id="userSetting_preferedTheme"
                        v-validate="'required|included:light,dark,system'"
                        data-vv-validate-on="change"
                        name="userSetting_preferedTheme"
                        v-on:change="validateBeforeSubmit"
                >
                  <option value="light">{{ $t("Lumineux") }}</option>
                  <option value="dark">{{ $t("Sombre") }}</option>
                  <option value="system">{{ $t("IdentiqueAuSysteme") }}</option>
                </select>
              </div>

              <p class="help is-danger has-text-left" id="error_userSetting_preferedTheme">
                {{ errors.first('userSetting_preferedTheme') }}</p>

            </div>

            <!--WTF !? : j'ai ajouté le champs .dummyField input hidden car avec un seul champ sur la page je ne parvenais pas à soumettre le form avec al touche enter ! @link :https://stackoverflow.com/questions/1370021/why-does-forms-with-single-input-field-submit-upon-pressing-enter-key-in-input-->
            <input type="text" style="display:none" class="dummyField">

          </div>
        </form>


      </div>


    </div>

  </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "../mixins/SentryMixin.js";
import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../mixins/InterceptorMixin.js";
import TrackingMixin from "@/mixins/TrackingMixin";

export default {
  name: 'UserSettingThemeComp',
  mixins: [SentryMixin, GlobalErrorNotification, InterceptorMixin, TrackingMixin],
  // components: {},
  data: function () {
    return {
      isSubmiting: false,     // indique si le formulaire est en cours de soumission
      organizationNameConfirmed: '', // le nom de l'organization entré dans le form pour confirmer la suppression du compte,
      themes: ['light', 'dark', 'system']
    }
  },
  computed: {
    // https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
    // computed props for store :
    ...mapState({
      organizationSlug: state => state.organization.slug,
      userSlug: state => state.user.slug

    }),
    //----------------------------------------------
    // vuex 2-way data binding forms https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
    preferedTheme: {
      get() {
        return this.$store.state.user.preferedTheme
      },
      set(value) {

        this.$store.commit('UpdateUserPreferedTheme', value)

        // création du cookie qui servira pour les cas ou l'utilisateur n'est pas authentifié
        this.$cookie.set('preferedTheme', value, {expires: 365})
      }
    },

  },

  methods: {

    /*
    * Valide le formulaire avant sa soumission
    */
    validateBeforeSubmit() {

      this.$store.commit('UpdateGlobalNotificationCompVisibility', false); // on masque un éventuel message à la soumission
      this.isSubmiting = true;

      let self = this
      this.$validator.validateAll().then((result) => {
        if (result) { // si la validation. réussie
          this.sendFormQuery();
        } else { // si il y a des erreurs...
          self.$store.commit('UpdateGlobalNotificationComp', {
            'isVisible': true,
            'color': 'is-danger',
            'message': self.$t('leFormulaireContientDesErreurs'),
          });
          this.isSubmiting = false;
        }

      })
    },

    /*
    Envoi la requête de soumission du formulaire
    */
    sendFormQuery() {

      let self = this;
      return self.$http
          .patch(`organizations/${self.organizationSlug}/users/${self.userSlug}`, {
                preferedTheme: self.preferedTheme
              },
              {headers: {Authorization: self.$auth.header()}}
          )
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

            if (response.status == 200) {
              self.$store.commit('UpdateGlobalNotificationComp', {
                'isVisible': true,
                'color': 'is-success',
                'message': self.$t('ThemeModifié'),
                'duration': 3200

              });

              self.ga4GlobalEventTrack('account theme modified' , {})
              self.$mixpanel.track("account theme modified");
            }
          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
              self.logToSentry(self, error, 'error')
              let errorCode = '0049'
              self.showGlobalErrorNotif(self, errorCode)
              self.$mixpanel.track('global error displayed', {"id": errorCode, "detail": "error in modify theme query"})
              self.$sentry.captureMessage(`Error ${errorCode} > error in modify theme query: ${error}`, 'error')
            }
          }).then(() => {
            // toujours exécuté
            self.isSubmiting = false;
          })

    },

  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)

  created: function () {


  },

  mounted: function () {
  },
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/globalVar.scss";

#formSectionTheme {

  .helpNomOrg {
    color: #666;
    font-style: normal;
  }

  .deleteWarning {
    background: $brandFourth;
    padding: 1px 4px;
    color: white;
  }
}


</style>
